import { render, staticRenderFns } from "./ProductCardCommunity.vue?vue&type=template&id=fd465974&scoped=true"
import script from "./ProductCardCommunity.vue?vue&type=script&lang=js"
export * from "./ProductCardCommunity.vue?vue&type=script&lang=js"
import style0 from "./ProductCardCommunity.vue?vue&type=style&index=0&id=fd465974&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd465974",
  null
  
)

export default component.exports